import * as React from 'react';
import {
  Field,
  FieldArray,
  reduxForm,
  WrappedFieldArrayProps,
  WrappedFieldProps,
} from 'redux-form';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';

import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import styles from './AgreementPage4.module.css';
import agreementStyles from '../ClientAgreement.module.css';
import { arrayNotEmpty, required } from '../../../shared/Forms/validations';
import { AscendState } from '../../../../ducks';
import { getNonEmptyDebts } from '../../../../ducks/onboard/onboardSelectors';
import { getInputAdornment } from '../../../shared/format';
import { formatDollar } from '../../../shared/Forms/formats';

const AgreementPage4 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="none" currentPage={4}>
    <div className={agreementStyles.contentHeader}>
      Exhibit 1<br />
      Creditors and Debt Schedule
      <br />
      <br />
      **IF YOU WOULD LIKE TO ADD OR REMOVE DEBTS OR CHANGE BALANCES, PLEASE CONTACT US.
      <br />
      <br />
    </div>
    <Grid
      item
      xs={12}
      container
      justify="center"
      style={props.isMobile ? { fontSize: '12px' } : {}}>
      <Grid container justify="center">
        <Grid item xs={4} container justify="center">
          <b>Creditor</b>
        </Grid>
        <Grid item xs={4} container justify="center">
          <b>Enrolled Balance</b>
        </Grid>
      </Grid>
      <FieldArray
        name="debts"
        isMobile={props.isMobile}
        component={RenderDebts as any}
        validate={arrayNotEmpty}
      />
    </Grid>
  </ContentContainer>
);

interface RenderDebtsProps {
  isMobile: boolean;
  disabled: boolean;
}

const RenderDebts = ({ fields, isMobile, meta }: WrappedFieldArrayProps<{}> & RenderDebtsProps) => (
  <>
    {fields.length === 0 && meta.error}
    {fields.map((member, index) => (
      <Grid key={index} container alignItems="center" justify="center">
        <Grid item xs={4} container justify="center" style={{ marginBottom: '1.5rem' }}>
          <Field
            name={`${member}.name`}
            type="text"
            isMobile={isMobile}
            component={DebtField}
            validate={required}
            disabled={true}
          />
        </Grid>
        <Grid item xs={4} container justify="center" style={{ marginBottom: '1.5rem' }}>
          <Field
            name={`${member}.balanceAtEnrollment`}
            type="text"
            format={formatDollar}
            isMobile={isMobile}
            component={DebtField}
            fieldFormat="dollar"
            validate={required}
            disabled={true}
          />
        </Grid>
      </Grid>
    ))}
  </>
);

const DebtField = (
  props: WrappedFieldProps & {
    type: string;
    isMobile: boolean;
    fieldFormat?: FieldFormat;
    disabled?: boolean;
  }
) => {
  return (
    <TextField
      {...props.input}
      error={props.meta.touched && !!props.meta.error}
      type={props.type}
      margin="normal"
      InputProps={{
        ...getInputAdornment(props.fieldFormat),
        style: props.isMobile ? { fontSize: '10px' } : {},
      }}
      className={styles.field}
      variant="outlined"
      disabled={props.disabled}
    />
  );
};

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AgreementPage4 as any);

export default connect((state: AscendState) => ({
  name: formSelector(state, 'name'),
  debts: getNonEmptyDebts(state),
  existingSignature: formSelector(state, 'clientSignature'),
}))(form) as any;
